import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';

export const useServiceFormatsVisibility = () => {
  const permissions = useUserPermissions();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRouteServicePointServiceFormatSelect,
    stationsFilter: !!permissions.servicePointFilterServiceFormatSelect
  }), [permissions]);
};
